import { capitalize } from "helpers/utils";
import { useEffect, useState } from "react";
import { Dropdown, Nav } from "react-bootstrap";
import { RouteItems, routes } from "sitemap";
import TopNavMegaMenu from "./TopNavMegaMenu";
import TopNavItem from "./TopNavItem";
import { useBreakpoints } from "providers/BreakpointsProvider";
import { useLocation, useNavigate } from "react-router-dom";

import { useAdminRolePermissions } from "permissions/AdminRolePermissionGate";


const NavbarTopNav = () => {
  const { filterSitemapRoutesByPermissions } = useAdminRolePermissions();
  const filteredRoutes = filterSitemapRoutesByPermissions(routes);

  return (
    <Nav className="navbar-nav-top navbar-nav-top-compact pb-4 pb-lg-0 scrollbar">
      {filteredRoutes.map((route) => (
        <NavbarTopNavItem route={route} key={route.label} />
      ))}
    </Nav>
  );
};

const NavbarTopNavItem = ({ route }: { route: RouteItems }) => {
  const navigate = useNavigate();

  const Icon  :any= route.icon;
  const path = route?.path;
  const [show, setShow] = useState(false);
  const { pathname } = useLocation();

  const { breakpoints } = useBreakpoints();
  const handleMouseEnter = () => {
    if (breakpoints.up("lg")) {
      setShow(true);
    }
  };

  const isActive = () => {
    if (route.label === "Project" && pathname === "/enquiry/project-inquiry") {
      return false;
    }
    
    return pathname === route.path || 
           pathname === route.mainPath || 
           pathname.startsWith(route.mainPath + '/') || 
           (route.pages && route.pages.some(page => pathname === page.path));
  };

  const handleMouseLeave = () => {
    if (breakpoints.up("lg")) {
      setShow(false);
    }
  };

  useEffect(() => {
    if (show) {
      setShow(false);
    }
  }, [pathname]);

  const handleClick = () => {};

  return (
    <Dropdown
      as="li"
      show={show}
      className={`nav-item ${isActive() ? `active` : ``}`}
      key={route.label}
      autoClose="outside"
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onToggle={() => setShow(!show)}
    >
      <Dropdown.Toggle
        as="a"
        variant=""
        className={`nav-link lh-1 d-flex align-items-center cursor-pointer ${
          isActive() || "/" + pathname.split("/")[1] === route.path?.split("/")[1]
            ? "text-primary"
            : ""
        }`}
        onClick={() => {
          if (route.path) {
            let path = route.path;
            navigate(`${path}`);
          }
        }}
      >
        {route.isCustomIcon ? route.customIcon :<Icon className="me-1" size={14} />}
        {/* {route.customIcon ? route.customIcon :<Icon className="me-2" size={16} />} */}
        
        <span>
          {capitalize(
            route.horizontalNavLabel ? route.horizontalNavLabel : route.label
          )}
        </span>
      </Dropdown.Toggle>
      {route.megaMenu ? (
        <TopNavMegaMenu route={route} />
      ) : (
        <TopNavItem route={route} />
      )}
    </Dropdown>
  );
};

export default NavbarTopNav;
